module.exports = __webpack_public_path__ + "img/LsgAudio14-18.b8b66594.jpeg";